import { FormSelectYesNo } from '../../formelements'

export const AuthSortidaAbsencia = ({auth, handleChange, error }) => 
{

return (
        <div className="row">
        <div className="col col-12 ">
        <h4>
            Autorització per sortir de l'institut en cas d'absència del professorat
        </h4>
        <p>
            Autoritzo a l'alumne/a a sortir de l'institut quan l'absència del professorat no pugui ser coberta, prèvia autorització del/ de la cap d'estudis o del/de la 
            coordinador/a. <br/>
            Període de validesa: aquesta autorització serà vàlida mentre l'alumne/a estigui matriculat en aquest centre. En cas que es vulgui anul·lar la seva validesa, caldrà notificar-ho a secretaria.
        </p>

        <FormSelectYesNo
            id="authSortidaAbsencia"
            name="authSortidaAbsencia"
            col="col-6"
            label="Trieu una opció:"
            obligatori={true}
            value={auth}
            handleChange={(e) => handleChange(e.target.value) } 
            error={error}
            />

        </div>
    </div>
     )
}